/* eslint-disable max-len */
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import {
    hooks as commonHooks,
    types as commonTypes,
    utils as commonUtils,
} from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import conditionalWrapper from './Conditional.styles';
import { DONOTHING, HIDE, RENDERNULL } from './index';

type actionOptions = typeof HIDE | typeof RENDERNULL | typeof DONOTHING;

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    functionToBoolean: string;
    action: actionOptions;
    typographyClass?: string;
}

const ConditionalRender = (props: commonTypes.WidgetInstanceProps): JSX.Element => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { styles, action, functionToBoolean } = widgetProperties || {};
    const widgetInstance = commonHooks.useWidgetInstance(props.widgetInstanceId);
    const { Placeholder } = commonHooks.useAppContext();

    const { data } = props;

    let transformReturn: any;

    const transformFunctionName = `${props.widgetInstanceId}-transform`;

    try {
        // eslint-disable-next-line no-new-func
        transformReturn = commonUtils.transformDataWithGlobals(
            transformFunctionName,
            functionToBoolean,
            {
                ...data,
            }
        );
    } catch (e) {
        console.warn(e);
    }

    const hideContent = action === HIDE;
    const renderNull = action === RENDERNULL;

    return (
        <div
            className={widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''}
            css={css`
                ${conditionalWrapper}${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles || ''}
            `}
        >
            {transformReturn !== null ? (
                <Placeholder
                    data={data}
                    /* transformReturn === false represent the default condition */
                    contentPlaceHolderId={
                        (transformReturn && hideContent !== true) || transformReturn === false
                            ? 'conditionalRender'
                            : ''
                    }
                    parentWidgetInstanceId={widgetInstance.id}
                    renderNull={transformReturn && renderNull}
                />
            ) : (
                'Use edit to configure'
            )}
        </div>
    );
};

export default ConditionalRender;
